<script setup lang="ts">
  import { watchDebounced } from '@vueuse/core';
  import { ref } from 'vue';

  import { Textarea } from '@ui/components/textarea';

  const props = defineProps<{ val: string; disabled?: boolean }>();

  const emit = defineEmits<{
    (e: 'resolve', value: string): void;
  }>();

  const value = ref(props.val || '');

  watchDebounced(
    value,
    (next) => {
      const trimmed = next?.trim() ?? '';
      if (trimmed === (props.val?.trim() ?? '')) return;
      emit('resolve', trimmed);
    },
    { debounce: 800 },
  );
</script>

<template>
  <Textarea
    v-model="value"
    :disabled="disabled"
    class="flex-1 min-h-12 resize-none bg-background text-xs"
    placeholder="Write your own response"
  />
</template>
